module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "button is-primary is-pulled-right",
    attrs: {
      "to": {
        name: 'admin-create'
      }
    }
  }, [_vm._v("\n        New Admin\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.admins), function(user) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'admin',
          params: {
            id: user.id
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(user.first_name) + " " + _vm._s(user.last_name) + "\n                ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(user.created_at, "from", "now")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(user.updated_at, "from", "now")))]), _vm._v(" "), _c('td', [(user.id !== _vm.admin.id) ? _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteAdmin(user)
        }
      }
    }) : _vm._e()])])
  }), 0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Login")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Last Updated")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8310c1b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/admins/AdminList.vue
// module id = 567
// module chunks = 0